// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","buttonWrap":"TextUpdatesCallout_buttonWrap__1E7MH","button":"TextUpdatesCallout_button__2mMEx"};